import { Button, Tooltip } from '@mantine/core';
import { useState } from 'react';

import {
  type ArenaRun,
  type ReportError,
  useCancelArenaRun,
  useDeleteArenaRun,
} from '../hooks/useModelArena';
import { isInFlight } from '../runGrouping';

import { DeleteRunModal } from './DeleteRunModal';

/** A run can be stopped while it is in flight and deleted once it is over, never both. */
export function RunActions({ run, reportError }: { run: ArenaRun; reportError: ReportError }) {
  const [confirmingDelete, setConfirmingDelete] = useState(false);
  const { cancelRun, isCancelling } = useCancelArenaRun(reportError);
  const { deleteRun, isDeleting } = useDeleteArenaRun(reportError);

  if (isInFlight(run)) {
    const consequence =
      run.status === 'QUEUED'
        ? 'Stops before it starts'
        : 'Stops after the candidate in flight finishes — a candidate cannot be interrupted';

    return (
      <Tooltip multiline w={260} label={consequence}>
        <Button
          size="compact-xs"
          variant="subtle"
          color="red"
          onClick={() => cancelRun(run.id)}
          loading={isCancelling}
        >
          Cancel
        </Button>
      </Tooltip>
    );
  }

  return (
    <>
      <Button
        size="compact-xs"
        variant="subtle"
        color="red"
        onClick={() => setConfirmingDelete(true)}
        loading={isDeleting}
      >
        Delete
      </Button>
      <DeleteRunModal
        run={run}
        opened={confirmingDelete}
        onClose={() => setConfirmingDelete(false)}
        onConfirm={() => {
          setConfirmingDelete(false);
          deleteRun(run.id, run.taskKey);
        }}
      />
    </>
  );
}
